import React, { Fragment, useState, useEffect, useRef } from "react";
import Moment from "react-moment";

import PostCommentsItem from "../IME/PostCommentsItem";
import PostReactionItem from "../IME/PostReactionItem";
import PostModal from "../IME/PostModal";
import ToggleButton from "../../PlayerButtons/ToggleButton";
import VolumeGreen from "../Innovators/VolumeGreen";
import VolumeRed from "../Mentors/VolumeRed";
import Volume from "../Employers/Volume";
import ProgressGreen from "../Innovators/ProgressGreen";
import ProgressRed from "../Mentors/ProgressRed";
import Progress from "../Employers/Progress";
import FontAwesomeIcon from "../IME/Icon";

const CampaignPostItem = ({
  comments,
  replies,
  reactions,
  post: {
    _id,
    post_deleted,
    role,
    channelid,
    pinned,
    text,
    avatar,
    image,
    video,
    gif,
    firstname,
    lastname,
    jobtitle,
    verified_account,
    date,
  },
  user,
  profile,
  profile_channelid,
  isAuthenticated,
  pinPost,
  unpinPost,
  addPostComment,
  AddReply,
  AddReaction,
  deletePost,
  DeleteReply,
  setShowReportUser,
  setReportedUser,
  moderators,
  deleteComment,
  setCommentReply,
  setShowPostReply,
  setReplyComment,
  setReplyToComment,
  setPostComment,
  setPostReply,
  Comment,
  Reply,
  setBannedUser,
  setShowBanUser,
  setShowBanUserComment,
  setShowBanUserReply,
}) => {
  const [showComments, setShowComments] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const videoRef = useRef(null);
  const videoPlayerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  const [truncate, setShowTruncate] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  const maxLength = 100;

  return (
    <Fragment>
      <div
        className={`community-posts ${
          profile.channelid === channelid ? "red" : "grey"
        }`}
      >
        <div className="post-top-container">
          <div className="flex-only-container">
            <div className="avi-border-container">
              <div
                className={`avi-color-border ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  alt="avatar"
                  className="post-avi"
                />
              </div>
            </div>
            <ul className="post-user-items">
              <div className="align-center">
                <li
                  className={`item-font ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  } bold`}
                >
                  {channelid}{" "}
                </li>
                {profile.channelid === channelid ? (
                  <i className="fa-solid fa-crown translate-y mx-5 gold"></i>
                ) : (
                  ""
                )}
                {verified_account && (
                  <div>
                    <i
                      className={`fa-regular fa-circle-check fa-sm ${
                        role && role === "innovator"
                          ? "green"
                          : role && role === "mentor"
                          ? "red"
                          : role && role === "employer"
                          ? "blue"
                          : ""
                      } mr-5`}
                    ></i>
                  </div>
                )}
              </div>
              <li className="stream-item bold">
                {firstname} {channelid !== "roland" ? lastname : ""}
              </li>
              <li className="stream-item">{jobtitle}</li>
            </ul>
          </div>
          <div>
            <div
              className={`post-date ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            >
              <Moment format="MM/DD/YYYY">{date}</Moment>
              {pinned && (
                <i
                  className={`fa-solid fa-thumbtack fa-lg mx-10 ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
              )}
              {pinned && user.channelid === profile.channelid && (
                <p
                  onClick={() => unpinPost(_id, profile.channelid)}
                  className="unpin"
                >
                  Unpin
                </p>
              )}
              {!pinned && user.channelid === profile.channelid && (
                <p
                  onClick={() => pinPost(_id, profile.channelid)}
                  className="unpin"
                >
                  Pin
                </p>
              )}
            </div>
          </div>
          {post_deleted && post_deleted ? (
            <div></div>
          ) : (
            isAuthenticated && (
              <div className="horizontal-ellipsis">
                {showModal && isAuthenticated && !user.banned && (
                  <PostModal
                    user={user}
                    profile={profile}
                    role={role}
                    channelid={channelid}
                    profile_channelid={profile.channelid}
                    _id={_id}
                    avatar={avatar}
                    firstname={firstname}
                    lastname={lastname}
                    text={text}
                    image={image}
                    video={video}
                    gif={gif}
                    deletePost={deletePost}
                    setShowReportUser={setShowReportUser}
                    setReportedUser={setReportedUser}
                    setShowModal={setShowModal}
                    moderators={moderators}
                    setBannedUser={setBannedUser}
                    setShowBanUser={setShowBanUser}
                  />
                )}
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className={`fa-solid fa-ellipsis cursor ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  } mx-5`}
                ></i>
              </div>
            )
          )}
        </div>
        <div className="post-middle-bottom-container">
          <div
            className={`${
              image !== "" && text === "" && video === "" && gif === ""
                ? "flex-only-center"
                : `${
                    text !== "" && image === "" && video === "" && gif === ""
                      ? "flex-only-center"
                      : `${
                          video !== "" &&
                          text === "" &&
                          image === "" &&
                          gif === ""
                            ? "flex-only-center"
                            : gif !== "" &&
                              text === "" &&
                              image === "" &&
                              video === ""
                            ? "flex-only-center"
                            : "flex-only-container"
                        }`
                  }`
            }`}
          >
            <div
              className={`${
                text !== "" && image === "" && video === "" && gif === ""
                  ? "post-text-media-alt"
                  : text !== "" && image !== "" && video === "" && gif === ""
                  ? "post-text-media"
                  : text !== "" && image === "" && video !== "" && gif === ""
                  ? "post-text-media"
                  : text !== "" && image === "" && video === "" && gif !== ""
                  ? "post-text-media"
                  : ""
              } text-padding`}
            >
              {text}
            </div>
            {image !== "" && (
              <div
                className={`${
                  image !== "" && text === "" && video === "" && gif === ""
                    ? "post-no-text-media-alt"
                    : "post-text-media"
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${image}`}
                  alt="media"
                  className="post-media"
                />
              </div>
            )}
            {video !== "" && (
              <div
                className={`${
                  video !== "" && text === "" && image === "" && gif === ""
                    ? "media-post"
                    : "post-text-media"
                }`}
                ref={videoPlayerRef}
              >
                <div
                  className={
                    showOverlay
                      ? "alt-video-overlay-pause-posts"
                      : "video-overlay-play-posts"
                  }
                >
                  <div className="alt-left-controls">
                    <ul className="controls">
                      {role && role === "innovator" && (
                        <VolumeGreen
                          className="Rac__volume"
                          onChange={(level) => {
                            const volume = level / 100;
                            videoRef.current.volume = volume;
                            videoRef.current.muted = volume === 0;
                          }}
                        />
                      )}
                      {role && role === "mentor" && (
                        <VolumeRed
                          className="Rac__volume"
                          onChange={(level) => {
                            const volume = level / 100;
                            videoRef.current.volume = volume;
                            videoRef.current.muted = volume === 0;
                          }}
                        />
                      )}
                      {role && role === "employer" && (
                        <Volume
                          className="Rac__volume"
                          onChange={(level) => {
                            const volume = level / 100;
                            videoRef.current.volume = volume;
                            videoRef.current.muted = volume === 0;
                          }}
                        />
                      )}
                    </ul>
                  </div>
                  <ToggleButton
                    className="alt-center-controls"
                    value={() => videoRef.current && !videoRef.current.paused}
                    onChange={(active) => {
                      if (!active) {
                        return videoRef.current.pause();
                      }

                      return videoRef.current.play();
                    }}
                  >
                    {(active) => {
                      if (
                        currentTime > 0.1 &&
                        currentTime < duration &&
                        active
                      ) {
                        setshowOverlay(false);
                        return (
                          <i
                            className={`far fa-pause-circle ${
                              role && role === "innovator"
                                ? "green"
                                : role && role === "mentor"
                                ? "red"
                                : role && role === "employer"
                                ? "blue"
                                : ""
                            } fa-3x`}
                            onClick={() => videoRef.current.pause()}
                          ></i>
                        );
                      } else {
                        setshowOverlay(true);
                      }
                      if (currentTime === duration) {
                        setCurrentTime(0);
                      } else if (currentTime === 0 && !videoRef.current.play) {
                        return (
                          <i
                            className={`far fa-play-circle ${
                              role && role === "innovator"
                                ? "green"
                                : role && role === "mentor"
                                ? "red"
                                : role && role === "employer"
                                ? "blue"
                                : ""
                            } fa-3x`}
                            onClick={() => videoRef.current.play()}
                          ></i>
                        );
                      }
                      return (
                        <i
                          className={`far fa-play-circle ${
                            role && role === "innovator"
                              ? "green"
                              : role && role === "mentor"
                              ? "red"
                              : role && role === "employer"
                              ? "blue"
                              : ""
                          } fa-3x`}
                          onClick={
                            videoRef.current && !videoRef.current.play
                              ? () => videoRef.current.play()
                              : setCurrentTime(0)
                          }
                        ></i>
                      );
                    }}
                  </ToggleButton>
                  {role && role === "innovator" && (
                    <ProgressGreen
                      className="Rac__progress-bar"
                      initial={0}
                      time={currentTime}
                      duration={duration}
                      onSkip={(time) => (videoRef.current.currentTime = time)}
                    />
                  )}
                  {role && role === "mentor" && (
                    <ProgressRed
                      className="Rac__progress-bar"
                      initial={0}
                      time={currentTime}
                      duration={duration}
                      onSkip={(time) => (videoRef.current.currentTime = time)}
                    />
                  )}
                  {role && role === "employer" && (
                    <Progress
                      className="Rac__progress-bar"
                      initial={0}
                      time={currentTime}
                      duration={duration}
                      onSkip={(time) => (videoRef.current.currentTime = time)}
                    />
                  )}
                  <div className="icon-flex-expand-settings">
                    <ToggleButton
                      className="Rac__screen-toggle"
                      initial={document.fullscreenElement}
                      onChange={(active) => {
                        if (!active && KeyboardEvent.key === "Escape") {
                          return document.exitFullscreen();
                        }

                        return videoPlayerRef.current.requestFullscreen({
                          navigationUI: "hide",
                        });
                      }}
                    >
                      {(active) => {
                        if (!active) {
                          return (
                            <FontAwesomeIcon
                              icon="expand"
                              size="lg"
                              className={`mt-4 ${
                                role && role === "innovator"
                                  ? "green"
                                  : role && role === "mentor"
                                  ? "red"
                                  : role && role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            />
                          );
                        }

                        if (active) {
                          return (
                            <FontAwesomeIcon
                              icon="compress"
                              size="lg"
                              className={`mt-4 ${
                                role && role === "innovator"
                                  ? "green"
                                  : role && role === "mentor"
                                  ? "red"
                                  : role && role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            />
                          );
                        }
                      }}
                    </ToggleButton>
                  </div>
                </div>
                <video
                  ref={videoRef}
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${video}`}
                  alt="media"
                  className={`${
                    video !== "" && text === "" && image === "" && gif === ""
                      ? "post-no-text-media-video"
                      : "post-text-media-full"
                  }`}
                ></video>
              </div>
            )}
            {gif !== "" && (
              <div
                className={`${
                  gif !== "" && text === "" && video === "" && image === ""
                    ? "post-no-text-media-alt"
                    : "post-text-media"
                }`}
              >
                <img src={gif} alt="media" className="post-media" />
              </div>
            )}
          </div>
          {post_deleted && post_deleted ? (
            <div></div>
          ) : (
            <div className="post-bottom-container">
              <PostReactionItem
                AddReaction={AddReaction}
                role={role}
                id={_id}
                channelid={profile.channelid}
                user={user}
                reactions={reactions}
              />
              {isAuthenticated && !user.banned && (
                <div
                  onClick={() => {
                    if (showComments && isAuthenticated) {
                      setShowComments(false);
                    } else {
                      setShowComments(true);
                    }
                  }}
                  className="post-flex-end"
                >
                  <p className="reaction-count-alt">
                    <i
                      className={`fa-solid fa-comments fa-lg mx-5 ${
                        role && role === "innovator"
                          ? "green"
                          : role && role === "mentor"
                          ? "red"
                          : role && role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>
                    <span className="count white">
                      {comments && comments.length > 0
                        ? comments.filter((x) => {
                            if (x && x.post_id !== undefined) {
                              return x.post_id.toString() === _id.toString();
                            }
                          }).length
                        : "0"}
                    </span>
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        {post_deleted && post_deleted ? (
          <div></div>
        ) : (
          showComments &&
          isAuthenticated && (
            <div className="profile-comments">
              <p className="hide-comments">
                <i
                  className={`fas fa-comment-slash fa-lg mx-5 ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  } cursor`}
                  onClick={() => {
                    setShowComments(false);
                    setShowTruncate(true);
                  }}
                ></i>
                <span
                  className="white cursor"
                  onClick={() => {
                    setShowComments(false);
                    setShowTruncate(true);
                  }}
                >
                  Hide Comments
                </span>
              </p>
              <div className="comment-reply-input-container-alt">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (Comment.text !== "") {
                      addPostComment(
                        _id,
                        profile_channelid,
                        Comment.text,
                        Comment.gif
                      );
                      setPostComment({ text: "", gif: "" });
                    }
                  }}
                  className="comment-reply-input-hidden"
                >
                  <input
                    type="text"
                    className="comment-reply-input"
                    name="comment"
                    maxLength={100}
                    value={Comment.text}
                    onChange={(e) =>
                      setPostComment({ ...Comment, text: e.target.value })
                    }
                    placeholder="Enter your comment here..."
                  />
                  {user &&
                    user.founding_supporter_type !== "Good" &&
                    user.founding_supporter_type !== "" && (
                      <div
                        className="gif-button-container red"
                        onClick={() => {
                          setCommentReply({
                            id: _id,
                            role,
                            channelid,
                            avatar,
                            firstname,
                            lastname,
                            jobtitle,
                            text: text !== "" ? text : "",
                            image: image !== "" ? image : "",
                            video: video !== "" ? video : "",
                            gif: gif !== "" ? gif : "",
                          });
                          setShowPostReply(true);
                        }}
                      >
                        <p className="gif-button">GIF</p>
                      </div>
                    )}
                  <p className="white character-counter-comment">
                    {Comment.text.split("").length}/{maxLength} characters
                  </p>
                  <button
                    className={`comment-reply-input-button ${
                      role && role === "innovator"
                        ? "background-green"
                        : role && role === "mentor"
                        ? "background-red"
                        : role && role === "employer"
                        ? "background-blue"
                        : ""
                    }`}
                  >
                    <i className="far fa-comments"></i>
                  </button>
                </form>
              </div>
              {comments &&
                comments.length > 0 &&
                comments.map((comment) => {
                  if (comment.post_id.toString() === _id.toString()) {
                    return (
                      <div>
                        <PostCommentsItem
                          key={comment._id}
                          comment={comment}
                          setShowComments={setShowComments}
                          id={_id}
                          profile={profile}
                          profile_channelid={profile.channelid}
                          user={user}
                          AddReply={AddReply}
                          replies={replies}
                          deleteComment={deleteComment}
                          DeleteReply={DeleteReply}
                          setShowReportUser={setShowReportUser}
                          setReportedUser={setReportedUser}
                          setReplyComment={setReplyComment}
                          setReplyToComment={setReplyToComment}
                          setPostReply={setPostReply}
                          Reply={Reply}
                          setBannedUser={setBannedUser}
                          setShowBanUser={setShowBanUser}
                          setShowBanUserComment={setShowBanUserComment}
                          setShowBanUserReply={setShowBanUserReply}
                          truncate={truncate}
                        />
                        {comment.replies &&
                          comment.replies.length > 5 &&
                          truncate && (
                            <div
                              onClick={() => {
                                if (truncate) {
                                  setShowTruncate(false);
                                } else {
                                  setShowTruncate(true);
                                }
                              }}
                              className="all-replies"
                            >
                              <p className="replies">
                                <i
                                  className={`fas fa-reply-all mx-5 ${
                                    role && role === "innovator"
                                      ? "green"
                                      : role && role === "mentor"
                                      ? "red"
                                      : role && role === "employer"
                                      ? "blue"
                                      : ""
                                  }`}
                                ></i>
                                All Replies
                              </p>
                            </div>
                          )}
                      </div>
                    );
                  }
                })}
            </div>
          )
        )}
        {showComments && (
          <p className="hide-comments">
            <i
              className={`fas fa-comment-slash fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              } cursor`}
              onClick={() => {
                setShowComments(false);
                setShowTruncate(true);
              }}
            ></i>
            <span
              className="white cursor"
              onClick={() => {
                setShowComments(false);
                setShowTruncate(true);
              }}
            >
              Hide Comments
            </span>
          </p>
        )}
      </div>
    </Fragment>
  );
};

export default CampaignPostItem;
